const getStorageType = (idConnectStorageType: string) =>
  typeof idConnectStorageType === 'string' &&
  idConnectStorageType === 'localStorage'
    ? 'localStorage'
    : 'sessionStorage';

const setSessionStorage =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (idConnectStorageType: string) => (key: string, data: any) =>
    window[getStorageType(idConnectStorageType)].setItem(
      key,
      JSON.stringify(data),
    );

const getSessionStorage = (idConnectStorageType: string) => (key: string) =>
  JSON.parse(window[getStorageType(idConnectStorageType)].getItem(key)!);

const removeSessionStorage = (idConnectStorageType: string) => (key: string) =>
  window[getStorageType(idConnectStorageType)].removeItem(key);

export const idConnectStorage = (idConnectStorageType: string) => ({
  set: setSessionStorage(idConnectStorageType),
  get: getSessionStorage(idConnectStorageType),
  remove: removeSessionStorage(idConnectStorageType),
});
